import React, { useState, useEffect } from 'react';
import { useTranslation } from '../i18n';

export default function DynamicLoading() {
  const { t } = useTranslation();
  const [currentText, setCurrentText] = useState('');

  const loadingSteps = [
    'exploration.loadingConnecting',
    'exploration.loadingRequesting',
    'exploration.loadingChecking',
    'exploration.loadingSearching',
    'exploration.loadingItinerary'
  ];

  useEffect(() => {
    let stepIndex = 0;
    setCurrentText(t(loadingSteps[stepIndex]));
    stepIndex = (stepIndex + 1) % loadingSteps.length;
    
    const interval = setInterval(() => {
      if (stepIndex < loadingSteps.length) {
        setCurrentText(t(loadingSteps[stepIndex]));
        stepIndex++;
      } else {
        clearInterval(interval);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [t]);

  return (
    <div className="loading-overlay">
      <div className="loading-spinner"></div>
      <p className="loading-text">{currentText}</p>
    </div>
  );
}